var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 25",
    style: {
      enableBackground: "new 0 0 24 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,0.6C5.4,0.6,0,6.1,0,12.7s5.4,12.1,12,12.1s12-5.4,12-12.1S18.6,0.6,12,0.6z M12,2.6c5.2,0,9.5,3.9,10,9.1 h-4c-0.4,0-0.7-0.1-1-0.4l-1-0.9c-0.6-0.5-1.3-0.7-2-0.7h-4c-0.7,0-1.4,0.3-1.9,0.7L7,11.3c-0.3,0.3-0.6,0.4-1,0.4H2 C2.6,6.6,6.9,2.6,12,2.6z M2,13.7h3.5c0.4,0,0.8,0.2,1.1,0.5l1.7,1.9c0.1,0.1,0.2,0.3,0.4,0.4l1.9,1.7c0.3,0.3,0.5,0.7,0.5,1.1v3.4 C6.3,22.3,2.5,18.6,2,13.7z M13.1,22.8v-3.5c0-0.4,0.2-0.8,0.5-1.1l1.9-1.7c0.1-0.1,0.3-0.2,0.4-0.4l1.7-1.9 c0.3-0.3,0.7-0.5,1.1-0.5H22C21.5,18.6,17.8,22.3,13.1,22.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWheel);
export default __webpack_public_path__ + "static/media/ico-wheel.afad38410157b7cc3c0ca0ac51fd0076.svg";
export { ForwardRef as ReactComponent };